export const getEstateTypeByTypeBien = typeBien => {
  switch (typeBien) {
    // APARTMENT
    case 'Appartement':
    case 'Loft/Atelier/Surface':
      return 'av_2'
    // BUILDING
    case 'Bâtiment':
    case 'Immeuble':
      return 'av_3'
    // HOUSE
    case 'Château':
    case 'Hôtel particulier':
    case 'Maison / Villa':
    case 'Modèle de maison':
      return 'av_5'
    // MISCELLANEOUS
    case 'Divers':
      return 'av_6'
    // OFFICE
    case 'Bureau':
    case 'Coworking':
    case 'Espace de coworking':
      return 'av_7'
    // PARKING
    case 'Parking':
      return 'av_8'
    // PLOT
    case 'Terrain':
      return 'av_9'
    // PROJECT
    case 'Programme':
      return 'av_10'
    // TRADING
    case 'Boutique':
    case 'Local commercial':
      return 'av_13'
    default:
      return ''
  }
}
